// i18n-ns: allBookings
import { getSlotTimeColumnDef, addRowsWithStaticFieldNameInMap, getSlotTimeRowKey } from '../../../utils/agGridUtils';
import { formatInteger, integerValueFormatter } from '../../../utils/numberUtils';

const cellStyle = (params) => {
    if (!params.value || params.value <= 0) return { justifyContent: 'center' };

    return { color: 'red', justifyContent: 'center' };
};

const cellRenderer = (params) => {
    if (!params.value) return '';

    // CALL-796: a cell renderer bypasses the column's valueFormatter, so read its output. `notranslate`
    // because this is a number that updates in place — see the translation-safety note in CLAUDE.md.
    return (
        <span
            className="notranslate"
            style={{
                padding: '0.5em 1em',
                backgroundColor: 'var(--primary)',
                borderRadius: '30px',
                color: 'var(--white)',
            }}
        >
            {params.valueFormatted}
        </span>
    );
};

export const createColumnDefs = (locations, allLocationsFromHEMT, t) => {
    const columns = [
        getSlotTimeColumnDef(),
        {
            field: 'availableBookings',
            headerName: t('legend.available'),
            maxWidth: 80,
            children: [
                {
                    field: 'availableBookings',
                    headerName: '',
                    valueFormatter: (params) => (params.value ? formatInteger(params.value) : '0'),
                    minWidth: 100,
                    // notranslate: a column-level cellClass replaces the shared defaultColDef's.
                    cellClass: 'grid-cell-centered notranslate',
                    cellStyle: {
                        justifyContent: 'center',
                        fontWeight: 'bold',
                    },
                },
            ],
        },
    ];

    for (const location of locations) {
        const locationFromTelefonica = allLocationsFromHEMT.find((loc) => loc.id === location.locationId);
        columns.push({
            field: `locationId${location.locationId}`,
            headerName: locationFromTelefonica ? locationFromTelefonica.city : location.id,
            children: [
                {
                    field: `lastBookedBookingValueLocationId${location.locationId}`,
                    headerName: '',
                    valueFormatter: (params) => (params.value ? formatInteger(params.value) : '0'),
                    minWidth: 30,
                    resizable: true,
                    // notranslate: a column-level cellClass replaces the shared defaultColDef's.
                    cellClass: 'grid-cell-centered notranslate',
                    cellStyle,
                },
                {
                    field: `oldestBookedBookingValueLocationId${location.locationId}`,
                    headerName: '',
                    resizable: false,
                    minWidth: 30,
                    valueFormatter: integerValueFormatter,
                    cellRenderer,
                },
            ],
        });
    }
    return columns;
};

export const createMapWithTableRows = (availableBookingsList, bookedBookingsList) => {
    let rowsMap = new Map();
    rowsMap = addRowsWithStaticFieldNameInMap(availableBookingsList, rowsMap, 'availableBookings', 'availableBookings');
    rowsMap = addBookingsInMap(bookedBookingsList, rowsMap);

    return rowsMap;
};

export const addBookingsInMap = (list, rowsMap) => {
    for (const item of list) {
        const key = getSlotTimeRowKey(item.slotDate);

        if (rowsMap.has(key)) {
            rowsMap.set(key, {
                ...rowsMap.get(key),
                [`lastBookedBookingValueLocationId${item.locationId}`]: item.bookedBookings,
                [`oldestBookedBookingValueLocationId${item.locationId}`]: item.oldestBookedBookings,
                [`bookingIdLocationId${item.locationId}`]: item.bookingId,
            });
        } else {
            rowsMap.set(key, {
                [`lastBookedBookingValueLocationId${item.locationId}`]: item.bookedBookings,
                [`oldestBookedBookingValueLocationId${item.locationId}`]: item.oldestBookedBookings,
                [`bookingIdLocationId${item.locationId}`]: item.bookingId,
            });
        }
    }

    return rowsMap;
};
